import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";
import moment from "jalali-moment";

function convertSecondsToTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0) {
    return `${convertNumbersToPersian(
      hours.toString()
    )} ساعت و ${convertNumbersToPersian(minutes.toString())} دقیقه`;
  } else {
    return `${convertNumbersToPersian(minutes.toString())} دقیقه`;
  }
}

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "white",
          padding: 10,
          border: "1px solid rgb(204, 204, 204)",
        }}
      >
        <p style={{ marginBottom: "10px" }}>{data.day}</p>
        {/* <p>{`زمان : ${(data.time / 60).toFixed(2)} ساعت`}</p> */}
        <p>{convertSecondsToTime(data.time)}</p>
      </div>
    );
  }
  return null;
};

const LineChartComponent = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart width={300} height={200} data={data}>
        <CartesianGrid strokeDasharray="0" />
        <XAxis dataKey="day" tick={null} height={0} />
        <Tooltip content={<CustomTooltip />} />
        <Line
          type="monotone"
          dataKey="time"
          stroke="#4b495b"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineChartComponent;
